<template>
  <div>
    <b-modal
      title="Edytuj kierowcę"
      @ok="sendForm"
      ok-title="Aktualizuj"
      cancel-title="Anuluj"
      centered
      size="lg"
      id="edit-emp"
      v-if="emp"
    >
      <b-alert show>Pamiętaj aby wprowadzić poprawny numer telefonu!</b-alert>
      <b-form-group :invalid-feedback="invalidName">
        <label for="fullName">Imię i nazwisko</label>
        <b-form-input
          v-model="emp.fullName"
          :state="!formValidate || null"
          trim
          id="fullName"
        />
      </b-form-group>
      <b-form-group
        label="Email"
        label-for="email"
        invalid-feedback="Wprowadź poprawny adres email"
      >
        <b-form-input
          v-model="emp.email"
          trim
          type="email"
          id="email
"
        />
      </b-form-group>
      <b-form-group
        label="Numer telefonu"
        label-for="phoneNumber"
        invalid-feedback="Wprowadź poprawny numer telefonu"
      >
        <b-input-group prepend="+48">
          <b-form-input
            v-model="emp.phoneNumber"
            trim
            type="number"
            id="phoneNumber"
          />
        </b-input-group>
      </b-form-group>
      <b-form-group
        label="Adres kierowcy"
        label-for="address"
        invalid-feedback="Wprowadź poprawny adres kierowcy"
      >
        <b-input-group>
          <b-form-input
            v-model="emp.address"
            trim
            type="text"
            id="address"
          />
        </b-input-group>
      </b-form-group>
      <b-form-group
        label="Pauza od"
        label-for="pauseStart"
        invalid-feedback="Wprowadź poprawny czas rozpoczęcia pauzy"
      >
        <b-form-input
          v-model="emp.onHoldStart"
          type="date"
          id="pauseStart"
        />
      </b-form-group>
      <b-form-group
        label="Pauza do"
        label-for="pauseEnd"
        invalid-feedback="Wprowadź poprawny czas zakończenia pauzy"
      >
        <b-form-input
          v-model="emp.onHoldEnd"
          type="date"
          id="pauseEnd"
        />
      </b-form-group>
    </b-modal>
  </div>
</template>

<script>
export default {
  props: ["emp"],
  data() {
    return {
      fullName: null,
      phone: null,
      formSent: false,
      onHoldStart: null,
      onHoldEnd: null,
      address: null,
    };
  },
  methods: {
    sendForm() {
      this.formSent = true;

      if (this.emp.phoneNumber && this.emp.fullName ) {
        this.$store.dispatch("updateDriverOnList", {
          id: this.emp.id,
          fullName: this.emp.fullName,
          email: this.emp.email,
          phone: this.emp.phoneNumber,
          onHoldStart: this.emp.onHoldStart,
          onHoldEnd: this.emp.onHoldEnd,
          address: this.emp.address,
        });
      } else {
        this.$bvModal.msgBoxOk("Upewnij się, że podałeś wszystkie dane.", {
          headerBgVariant: "danger",
          title: "Wystąpił błąd",
          okVariant: "danger",
          headerTextVariant: "light",
          centered: true,
        });
      }
    },
  },
  computed: {
    formValidate() {
      if (
        this.fullName &&
        this.fullName.trim().indexOf(" ") !== -1 &&
        !this.formSent &&
        this.phone &&
        this.phone.length > 6 &&
        this.email &&
        this.email.length > 5 
      ) {
        return false;
      } else {
        return true;
      }
    },
    invalidName() {
      if (this.fullName && this.fullName.trim().indexOf(" ") === -1) {
        return "Wprowadź imię i nazwisko";
      }
    },
  },
};
</script>

<style>
.row .col .singleday {
  border: 1px solid black;
  text-align: center;
  height: 100px;
  -webkit-touch-callout: none; /* iOS Safari */
  -webkit-user-select: none; /* Safari */
  -khtml-user-select: none; /* Konqueror HTML */
  -moz-user-select: none; /* Old versions of Firefox */
  -ms-user-select: none; /* Internet Explorer/Edge */
  user-select: none; /* Non-prefixed version, currently
                                  supported by Chrome, Edge, Opera and Firefox */
}
.selected {
  background-color: #808080;
  color: #fff;
}
</style>
